<template>
    <div class="om_list_wrap">
        <!--        <div class="om_text">-->
        <!--            <span>{{ $t('openMarket') }}</span>-->
        <!--        </div>-->
        <div class="om_tap_wrap">
            <button class="om_tap" :class="{ active : tab === '0'}"
                    @click="changeTab('0')">{{ $t('all') }}
            </button>
            <button class="om_tap" :class="{ active : tab === `${data.node_id}`}" v-for="data in itemCategoryList"
                    v-if="data.node_id !=4"
                    :key="`category${data.node_id}`"
                    @click="changeTab(`${data.node_id}`)">{{ returnCategoryName(data) }}
            </button>
        </div>
        <div class="om_best_item_text">
            BEST NFT ITEMS
        </div>
        <div v-if="tab === '0'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <div v-if="tab === '2'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <div v-if="tab === '3'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <div v-if="tab === '4'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <div v-if="tab === '5'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <div v-if="tab === '9'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <div v-if="tab === '178'">
            <div class="om_thumbnail_box">
                <item-list-market-top-component :item-type="'openMarketTopBanner'"
                                                :category-key="tab"></item-list-market-top-component>
            </div>
            <item-list-component :item-type="'openMarket'" :category-key="tab"></item-list-component>
        </div>
        <filter-modal></filter-modal>
        <transition :name="`detail-${$root.$children[0].transitionName}`">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
import ItemListComponent from "@/components/item/ItemListComponent";
import AuctionHistoryModal from "@/components/modal/AuctionHistoryModal";
import FilterModal from "@/components/modal/FilterModal";
import {mapState} from "vuex";
import util from "@/mixins/util";
import ItemListMarketTopComponent from "@/components/item/itemListMarketTopComponent";

export default {
    metaInfo: {
        title: `오픈마켓(Openmarket)`,
        titleTemplate: '%s | 밍글민트(Minglemint NFT Marketplace)',
    },
    name: "OpenMarket",
    mixins: [],
    components: {
        ItemListMarketTopComponent,
        ItemListComponent,
        AuctionHistoryModal,
        FilterModal,
    },
    inject: [],
    provide() {
        return {}
    },
    props: {},
    data() {
        return {
            tab: 0,
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.tab = this.$route.query.tab;
        if (util.isEmpty(this.tab)) {
            this.changeTab('0');
        }
    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            itemCategoryList: state => state.itemCategory.itemCategoryList,
        })
    },
    methods: {
        changeTab(tab) {
            this.tab = ''
            this.$nextTick(() => {
                this.tab = tab;
            })
            this.$router.replace(`${this.$route.path}?tab=${tab}`);
        },
        returnCategoryName(data) {

            if (data.node_id === 2) {
                return this.$t('art');
            } else if (data.node_id === 3) {
                return this.$t('picture');
            } else if (data.node_id === 4) {
                return this.$t('video');
            } else if (data.node_id === 5) {
                return this.$t('music');
            } else if (data.node_id === 9) {
                return this.$t('collections');
            } else if (data.node_id === 178) {
                return this.$t('prompt');
            }
        },
    },
    watch: {
        // "$route.fullPath": {
        //     deep: true,
        //     handler: function (val, oldVal) {
        //         if (this.tab != this.$route.query.tab) {
        //             this.changeTab(this.$route.query.tab);
        //         }
        //     }
        // }
    },
}
</script>

<style scoped>

</style>